import apiClient from './api'

export type LegalDocumentType = 'TERMS' | 'PRIVACY' | 'AI_DISCLOSURE'

export interface LegalDocument {
    type: LegalDocumentType
    version: string
    hash: string
    content: string
}

export interface LegalStatusItem {
    type: LegalDocumentType
    version: string
    hash: string
    accepted: boolean
}

export interface LegalStatus {
    allAccepted: boolean
    documents: LegalStatusItem[]
}

export const legalService = {
    /** Documento legal vigente (público; usado por /terms y /privacy). */
    async getDocument(type: LegalDocumentType): Promise<LegalDocument> {
        const { data } = await apiClient.get<LegalDocument>(`/api/v1/legal/documents/${type}`)
        return data
    },

    /** Estado de aceptación del usuario autenticado. */
    async getStatus(): Promise<LegalStatus> {
        const { data } = await apiClient.get<LegalStatus>('/api/v1/legal/status')
        return data
    },

    /** Registra la aceptación de un documento (versión + hash vigentes). */
    async accept(type: LegalDocumentType, version: string, hash: string): Promise<void> {
        await apiClient.post('/api/v1/legal/accept', { type, version, hash })
    },
}
